import React from 'react';

import ComingSoon from '../../ComingSoon';

export const TroubleshootingDetailSettings = () => (
    <>
        <ComingSoon></ComingSoon>
    </>
);
